import AbstractProvidedClass from "../../../shared/AbstractProvidedClass";

export default class DeleteAction extends AbstractProvidedClass {
    constructor(provider, elements) {
        super(provider);

        this.collection = {};
        elements.map((el) => {
            const index = this.elements.indexOf(el);
            this.collection[index] = el;
        });

        // Sort the collection object by keys
        this.collection = Object.keys(this.collection).sort().reduce((acc, key) => {
            acc[key] = this.collection[key];
            return acc;
        }, {});
    }

    finish() {
        this.elements.delete(Object.values(this.collection));
        this.provider.actions.finish();
    }

    undo() {
        Object.keys(this.collection).map((index) => {
            this.elements.add(this.collection[index], index);
        });
    }

    redo() {
        this.elements.delete(Object.values(this.collection));
    }
}
